export default __webpack_public_path__ + "assets/models/82f76fae4497104b1ce59f872211760d.glb";